import React, {useEffect} from 'react'
import {Alert, Box, CloseButton, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import CheckIcon from '../../components/icons/others/CheckIcon'

const CustomToast = ({message, status, onClose, duration = 5000}) => {
    const styles = useMultiStyleConfig('Account', {variant: 'customToast'})
    useEffect(() => {
        const timer = setTimeout(onClose, duration)
        return () => clearTimeout(timer)
    }, [onClose, duration])

    return (
        <Alert status={status} variant="left-accent" sx={styles.customToast.container}>
            <CheckIcon sx={styles.customToast.icon} />
            <Box flex="1" sx={styles.customToast.title}>
                {message}
            </Box>
            <CloseButton sx={styles.customToast.closeButton} onClick={onClose} />
        </Alert>
    )
}

CustomToast.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    duration: PropTypes.number,
}

export default CustomToast
